import './menu_toggle_component.scss'
import { Controller } from 'stimulus'

export default class extends Controller {
  static classes = ['hide']

  connect (): void {
    this.toggleVisibility()
  }

  toggle = (): void => {
    this.menuSectionController.toggleCollapse()
    this.toggleVisibility()
  }

  toggleVisibility = (): void => {
    if (this.menuSectionController.collapsed === true) {
      this.element.classList.remove(this.hideClass)
    } else {
      this.element.classList.add(this.hideClass)
    }
  }

  get siblingControllers (): object[] {
    return this.navigationController.menuToggleControllers
  }

  get menuSectionController (): object {
    return this.application.getControllerForElementAndIdentifier(this.element.closest('.menu_section'), 'menu-section')
  }

  get navigationController (): object {
    return this.menuSectionController.navigationController
  }
}
